import { Component, OnInit, ViewChild } from '@angular/core';
import { MatDialog, MatPaginator, MatTableDataSource } from '@angular/material';
import { ConfirmComponent } from 'src/app/components/confirm/confirm.component';
import { SoundEnum } from 'src/app/enums/sound.enum';
import { IConfirm } from 'src/app/interfaces/confirm';
import { SnackBarService } from 'src/app/services/common/snackBar.service';
import { SurveyService } from 'src/app/services/http/business/survey/survey.service';
import { SurQuestionCatAddComponent } from '../sur-question-cat-add/sur-question-cat-add.component';
import { SurQuestionCatEditComponent } from '../sur-question-cat-edit/sur-question-cat-edit.component';
import { SurQuestionCatSearchComponent } from '../sur-question-cat-search/sur-question-cat-search.component';
import { SurQuestionListComponent } from '../sur-question-list/sur-question-list.component';

@Component({
  selector: 'app-sur-question-cat',
  templateUrl: './sur-question-cat.component.html',
  styleUrls: ['./sur-question-cat.component.css']
})
export class SurQuestionCatComponent implements OnInit {

  filter = {
    LevelInfoId: null,
    PackageId: null,
    Title: null
  }

  displayedColumns: string[] = [
    'title',
    'level',
    'package',
    'function'
  ];

  dataSource = new MatTableDataSource();

  @ViewChild(MatPaginator) paginator: MatPaginator;

  constructor(
    private surService: SurveyService,
    private snackBar: SnackBarService,
    private dialog: MatDialog
  ) { }

  ngOnInit() {
    this.list(this.filter, 0, 10);
  }

  search() {
    this.dialog
      .open(SurQuestionCatSearchComponent, {
        width: "450px"
      })
      .afterClosed()
      .subscribe(
        res => {
          if (res) {
            this.filter.LevelInfoId = res.LevelInfoId;
            this.filter.PackageId = res.PackageId;
            this.filter.Title = res.Title;
            this.list({
              LevelInfoId: res.LevelInfoId,
              PackageId: res.PackageId,
              Title: res.Title
            }, 0, 10);
          }
        }
      );
  }

  add() {
    this.dialog
      .open(SurQuestionCatAddComponent, {
        width: "350px"
      }).afterClosed().subscribe(res => {
        if (res)
          this.clearFilter();
      })
  }

  showQuestion(data: any) {
    this.dialog
      .open(SurQuestionListComponent, {
        width: "80%",
        data: data
      })
  }

  edit(data: any) {
    this.dialog
      .open(SurQuestionCatEditComponent, {
        width: "400px",
        data: data
      }).afterClosed().subscribe(res => {
        if (res)
          this.list(this.filter, this.paginator.pageIndex, this.paginator.pageSize);
      })
  }


  delete(data: any) {
    let confirm: IConfirm = {
      accept: true,
      message: 'آیا از حذف دسته بندی سوال اطمینان دارید؟',
      alert: null,
      yesLabel: 'بله',
      noLabel: 'خیر'
    };

    const dialogRef = this.dialog.open(ConfirmComponent, {
      width: "250px",
      data: confirm
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.surService.delete(data).subscribe(
          () => {
            this.snackBar.OpenSnackBar(
              "حذف با موفقیت انجام شد",
              "ok",
              5000,
              SoundEnum.beep
            );
            this.list(this.filter, this.paginator.pageIndex, this.paginator.pageSize);
          },
          () => {
            this.snackBar.OpenSnackBar(
              "حذف با خطا مواجه شد",
              "ok",
              5000,
              SoundEnum.beep
            );
          }
        );
      }
    });
  }

  clearFilter() {
    this.filter.LevelInfoId = null;
    this.filter.PackageId = null;
    this.filter.Title = null;
    this.list({ LevelInfoId: null, PackageId: null, Title: null }, 0, 10)
  }

  list(filter: any, page: number, pageSize: number) {
    this.surService.catList(filter, page + 1, pageSize).subscribe(res => {
      this.dataSource.data = res.DataList;
      this.paginator.length = res.Total;
      this.paginator.pageIndex = page;
      this.paginator.pageSize = pageSize;
    })
  }

  paginatorEvent(event) {
    this.surService.catList(this.filter, event.pageIndex + 1, event.pageSize)
      .subscribe(res => {
        this.dataSource.data = res.DataList;
        this.paginator.length = res.Total;
      });
  }

}
